
import { Mixins, Component, Prop, Ref } from "vue-property-decorator";
import {
  SmartImage,
  SmartText,
  SmartImageProps,
  SmartSVG,
  SVGLibraryCustom,
  CTAButton,
} from "_components";
import { onScroll, onView, onResize } from "_mixins";
import { HomePageNextEventSectionType } from "../../types";
import Roller from "./Roller.vue";
import HeroText from "./HeroText.vue";
import Blur from "./Blur.vue";
import WebGL from "./WebGL.vue";

// import WebGL from "./WebGL2.vue";
// import Spline from "vue-spline";

@Component({
  name: "HomeNextEvent",
  components: {
    SmartText,
    SmartImage,
    SmartSVG,
    Roller,
    HeroText,
    CTAButton,
    Blur,
    // Spline,
    WebGL,
  },
})
export default class HomeNextEvent extends Mixins(onScroll, onView, onResize) {
  @Prop({ required: true }) data: HomePageNextEventSectionType;
  @Ref() title: SmartText;
  @Ref() pseudoTitle: SmartText;
  @Ref() wrapper: HTMLElement;
  @Ref() heroTextRef: HeroText;

  rootClass = "p-home-next-event";
  SVGLibraryCustom = SVGLibraryCustom;

  get eventTitle() {
    return this.data.text.title ? this.data.text.title : "RARE";
  }

  get enableCountdown() {
    return this.data.enable_countdown && this.data.enable_countdown;
  }

  get eventStart() {
    return this.data.event_start && this.data.event_start;
  }

  get imageSettings(): SmartImageProps {
    return (
      this.data.image && {
        image: this.data.image,
        lazyload: true,
        fit: "cover",
      }
    );
  }

  get date() {
    return this.data.text.date && this.data.text.date;
  }

  get secondaryLinks() {
    return this.data.links && this.data.links.secondary_links
      ? this.data.links.secondary_links
      : [];
  }

  get text() {
    return this.data.text.text ? this.data.text.text : "";
  }

  get primaryLink() {
    return this.data.links && this.data.links.link;
  }

  recalc() {
    if (this.heroTextRef) this.heroTextRef.calc();
  }
}
